let pageConfig = {};

/** 嵌入式版本号：有内容时首字符须为 v / V */
function validateEmbeddedSoftVersionPrefix(rule, value, callback) {
  const s = value != null ? String(value).trim() : "";
  if (!s) {
    callback();
    return;
  }
  const first = s.charAt(0);
  if (first !== "v" && first !== "V") {
    callback(new Error("嵌入式版本号须以 V 开头（不区分大小写）"));
    return;
  }
  callback();
}

// 列表展示项
pageConfig.listColumns = [
  {
    label: "充电桩显示名称",
    props: "showName",
    minWidth: 300,
  },
  {
    label: "充电桩类型",
    props: "chargingPileType",
    minWidth: 200,
     formatter: (row) => {
      if (row.chargingPileType == "WALL_MOUNTED") {
        return "壁挂式";
      } else if (row.chargingPileType == "PORTABLE") {
        return "便携式";
      } else if (row.chargingPileType == "WULING") {
        return "五菱桩";
      } else {
        return "";
      }
    },
  },
  {
    label: "充电桩型号",
    props: "pileTypeName",
    minWidth: 200,
  },
  {
    label: "默认嵌入式版本号",
    props: "softVersion",
    minWidth: 200,
  },
  {
    label: "规格",
    props: "specificationName",
    minWidth: 200,
  },
  {
    label: "成品料号",
    props: "materialNo",
    minWidth: 200,
  },
  {
    label: "业务归属",
    props: "businessBelongName",
    minWidth: 200,
    formatter: (row) => {
      if (row.businessBelong == "01") {
        return "电商";
      } else if (row.businessBelong == "02") {
        return "非电商";
      } else {
        return "";
      }
    },
  },
  {
    label: "创建人",
    props: "createdByName",
    minWidth: 200,
  },
  {
    label: "创建时间",
    props: "createdWhen",
    minWidth: 200,
  },
  {
    label: "更新人",
    props: "lastModifiedByName",
    minWidth: 200,
  },
  {
    label: "更新时间",
    props: "lastModifiedWhen",
    minWidth: 200,
  },
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "系统配置",
  },
  {
    type: "title",
    name: "充电桩基础信息管理",
  },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "userId",
  editRouter: "ChargingPileDetail",
};

// 路由
pageConfig.listRouter = "ChargingPile";

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页",
  },
  {
    type: "title",
    name: "系统配置",
  },
  {
    type: "router",
    name: "充电桩基础信息管理",
    router: "ChargingPile",
  },
  {
    type: "title",
    name: "新增",
  },
];

pageConfig.formRules = {
  hasReservation: [
    {
      required: true,
      message: "请选择预约充电",
      trigger: "change",
    },
  ],
  hasCurrentAdjustable: [
    {
      required: true,
      message: "请选择电流调节",
      trigger: "change",
    },
  ],
  hasFamilySharing: [
    {
      required: true,
      message: "请选择亲友共享",
      trigger: "change",
    },
  ],
  hasChargingAlarm: [
    {
      required: true,
      message: "请选择充电闹钟",
      trigger: "change",
    },
  ],
  upgradeMethod: [
    {
      required: true,
      message: "请选择设备升级",
      trigger: "change",
    },
  ],
  hasNationalStandardCompatibility: [
    {
      required: true,
      message: "请选择国际兼容设置",
      trigger: "change",
    },
  ],
  activityType: [
    {
      required: true,
      message: "请选择参与活动类型",
      trigger: "change",
    },
  ],
  hasCardSwipingSupported: [
    {
      required: true,
      message: "请选择是否支持刷卡",
      trigger: "change",
    },
  ],
  hasPrivatePileSharing: [
    {
      required: true,
      message: "请选择私桩共享",
      trigger: "change",
    },
  ],
  showName: [
    {
      required: true,
      message: "请输入充电桩显示名称",
      trigger: "blur",
    },
  ],
  pileTypeName: [
    {
      required: true,
      message: "请输入充电桩型号",
      trigger: "blur",
    },
  ],
  specificationName: [
    {
      required: true,
      message: "请输入规格",
      trigger: "blur",
    },
  ],
  bigName: [
    {
      required: true,
      message: "存货大类名称",
      trigger: "blur",
    },
  ],
  materialNo: [
    {
      required: true,
      message: "请输入成品料号",
      trigger: "blur",
    },
  ],
  manufactorId: [
    {
      required: true,
      message: "请输入厂家标识",
      trigger: "blur",
    },
  ],
  manufactorCode: [
    {
      required: true,
      message: "请输入厂家编码",
      trigger: "blur",
    },
  ],
  businessBelong: [
    {
      required: true,
      message: "请选择业务归属",
      trigger: "change",
    },
  ],
  pileVersionNo: [
    {
      required: true,
      message: "请选择版本类型",
      trigger: "change",
    },
  ],
  ratedCurrent: [
    {
      required: true,
      message: "请输入额定电流",
      trigger: "blur",
    },
  ],
  ratedVoltage: [
    {
      required: true,
      message: "请输入额定电压",
      trigger: "blur",
    },
  ],
  ratedPower: [
    {
      required: true,
      message: "请输入额定功率",
      trigger: "blur",
    },
  ],
  phaseType: [
    {
      required: true,
      message: "请选择单项桩/三项桩",
      trigger: "change",
    },
  ],
  gunNum: [
    {
      required: true,
      message: "请输入充电枪数量",
      trigger: "blur",
    },
  ],
  chargingSpeed: [
    {
      required: true,
      message: "请选择充电速度",
      trigger: "change",
    },
  ],
  interfaceType: [
    {
      required: true,
      message: "请选择接口类型",
      trigger: "change",
    },
  ],
  currentOutType: [
    {
      required: true,
      message: "请选择电流输出类型",
      trigger: "change",
    },
  ],
  bluetoothFlag: [
    {
      required: true,
      message: "请选择蓝牙功能",
      trigger: "change",
    },
  ],
  offHandChargingFlag: [
    {
      required: true,
      message: "请选择即插即充",
      trigger: "change",
    },
  ],
  cardFlag: [
    {
      required: true,
      message: "请选择无感充电",
      trigger: "change",
    },
  ],
  audioType: [
    {
      required: true,
      message: "请选择音频类型",
      trigger: "change",
    },
  ],
  networkStatus: [
    {
      required: true,
      message: "请选择联网方式",
      trigger: "change",
    },
  ],
  bluetoothPairFlag: [
    {
      required: true,
      message: "请选择蓝牙配置",
      trigger: "change",
    },
  ],
  isGreenEnergy: [
    {
      required: true,
      message: "请选择是否发放蚂蚁森林能量",
      trigger: "change",
    },
  ],
  isActivity: [
    {
      required: true,
      message: "请选择是否参加活动",
      trigger: "change",
    },
  ],
  adjustPower: [
    {
      required: true,
      message: "请选择是否支持智能充电",
      trigger: "change",
    },
  ],
  isScreen: [
    {
      required: true,
      message: "请选择是否带屏桩",
      trigger: "change",
    },
  ],
  warrantyTimeStatus: [
    {
      required: true,
      message: "请选择质保赠送时间",
      trigger: "change",
    },
  ],
  networkTimeStatus: [
    {
      required: true,
      message: "请选择流量赠送时间",
      trigger: "change",
    },
  ],
  useState: [
    {
      required: true,
      message: "请选择状态",
      trigger: "change",
    },
  ],
  status: [
    {
      required: true,
      message: "请选择状态",
      trigger: "change",
    },
  ],
  softVersion: [
    {
      validator: validateEmbeddedSoftVersionPrefix,
      trigger: "blur",
    },
  ],
};

export { validateEmbeddedSoftVersionPrefix };
export default pageConfig;
